export const OPTION_TAB = {
    userMarketSelectTab: 'userMarketSelectTab',
    userMarketProductDeliveredTab: 'userMarketProductDeliveredTab',
    userMarketPromoCodeTab: 'userMarketPromoCodeTab',
    userMarketQRCodeTab: 'userMarketQRCodeTab',
    userMarketSummaryTab: 'userMarketSummaryTab',
  };
  
export const initialState = {
    prevTab: 'userMarketSelectTab',
    currentTab: 'userMarketSelectTab',
  };

  
export const RedeemMethodEnum  = {
    QR_CODE : 'QrCode',
    PROMO_CODE : 'PromoCode',
    FREE_ITEM_DELIVERED : 'FreeItemDelivered',
  }

export const MarketplaceFilterItems = {
  POINTS: 'points',
  BRANDS: 'brands',
  CATEGORIES: 'categories'
}

export const MARKETPLACE_PAGINATION = {
  PAGE_SIZE: 50,
  DEFAULT_PAGE: 1
}